import { render } from "./ChatClaim.vue?vue&type=template&id=82319cbc"
import script from "./ChatClaim.vue?vue&type=script&lang=js"
export * from "./ChatClaim.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__